import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import H1 from "../H1";
import { replaceWithDataSource } from "../helpers/variable";
// import { TransitionGroup, CSSTransition } from "react-transition-group";

export default function Lyrics({ cue, cloud }) {
	const { projectId } = useParams();
	const selectedProject = useSelector(
		(state) => state?.main?.projects?.[projectId]
	);

	const baseTheme = useSelector((state) =>
		cloud
			? state?.projects?.[projectId + "_themes"]?.[cue.theme]
			: cue.theme
			? state?.main?.projects?.[projectId]?.themes?.[cue.theme]
			: state?.main?.projects?.[projectId]?.themes?.[selectedProject?.theme]
	);
	const baseThemeId = cue.theme ? cue.theme : selectedProject?.theme;
	return (
		<>
			{/* <TransitionGroup>
				<CSSTransition
					key={cue.lyrics?.[cue.currentLyric]}
					classNames="fade"
					timeout={200}
				> */}
			<div className="w-s9 h-auto whitespace-pre-line">
				<H1
					cue={cue}
					text={cue.lyrics?.[cue.currentLyric] || ""}
					baseTheme={baseTheme}
					baseThemeId={baseThemeId}
					whitespace={""}
					forceHeight={cue.lyrics?.[cue.currentLyric] ? false : true}
				/>
			</div>
			{/* </CSSTransition>
			</TransitionGroup> */}
		</>
	);
}
